<div
    class="font-inter w-full h-full bg-[linear-gradient(359deg,_#FFF_83.33%,_var(--latte-50,_#F9F5F0)_99.08%)]">
    <div class="w-full h-full p-4">
        <div class="text-center z-10 relative mb-6">
            <div class="text-color text-base leading-[normal] font-semibold font-normal"
                >Session at {{ sessionTimeStr }}
            </div>
            <div class="text-muted-color text-[13px] leading-[normal]">{{
                sessionDateAndDurationStr
            }}</div>
        </div>
        <div
            class="w-full"
            *ngIf="
                xhrPartners.state == 'loading' || xhrPartners.state == 'initial';
                else listLoaded
            ">
            <app-loading-indicator></app-loading-indicator>
        </div>
        <ng-template #listLoaded>
            <div class="w-full xflex-1 h-[calc(100%_-_192px)]">
                <p-scrollpanel [style]="{ width: '100%', height: '100%' }" styleClass="w-full">
                    <div
                        class="only:mb-0 mt-2 first:mt-0"
                        *ngFor="let partner of directBookPartnerList; let i = index">
                        <app-timeslot-partner-item
                            (click)="onClickUpdateDirectBookPartnerListItemSelected(i)"
                            [displayName]="partner.displayName"
                            [saved]="partner.saved"
                            [profileImage]="partner.profilePhoto"
                            [profileUrl]="partner.profileSlug"
                            [totalSessions]="partner.totalSessions"
                            [sharedSessions]="partner.sharedSessions"
                            [lastSessionTogether]="partner.lastSessionTime"
                            [timezone]="partner.timezone"
                            [selected]="directBookPartnerListItemSelected == i"
                            [activityType]="partner.activityType"
                            [quietMode]="partner.preferences.quietMode.value" />
                    </div>
                    <div class="only:mb-0 mt-2 first:mt-0">
                        <!-- Remove non-favorites from list -->
                        <!-- @if (mostLikelyRandomPartner) {
                            <app-timeslot-partner-item
                                class="list-item"
                                (click)="onClickSetIsmostLikelyRandomPartnerSelected()"
                                [displayName]="mostLikelyRandomPartner.displayName"
                                [saved]="mostLikelyRandomPartner.saved"
                                [profileImage]="mostLikelyRandomPartner.profilePhoto"
                                [profileUrl]="mostLikelyRandomPartner.profileSlug"
                                [totalSessions]="mostLikelyRandomPartner.totalSessions"
                                [sharedSessions]="mostLikelyRandomPartner.sharedSessions"
                                [lastSessionTogether]="mostLikelyRandomPartner.lastSessionTime"
                                [timezone]="mostLikelyRandomPartner.timezone"
                                [selected]="ismostLikelyRandomPartnerSelected"
                                [quietMode]="
                                    mostLikelyRandomPartner.preferences.quietMode.value
                                "></app-timeslot-partner-item>
                        } @else { -->
                        <app-timeslot-partner-item
                            (click)="onClickSetIsmostLikelyRandomPartnerSelected()"
                            [isRandomCommunityMemberSlot]="true"
                            [selected]="ismostLikelyRandomPartnerSelected">
                        </app-timeslot-partner-item>
                        <!-- } -->
                    </div>
                </p-scrollpanel>

                <p-button
                    severity="primary"
                    class="w-full mt-6"
                    styleClass="w-full"
                    [loading]="loading"
                    (click)="onClickedBookSession()">
                    @if (!ismostLikelyRandomPartnerSelected) {
                        <fa-icon [icon]="faLock"></fa-icon>
                    }

                    <span class="font-semibold">Confirm for {{ sessionTimeStr }}</span>
                </p-button>

                <!-- <div class="std-modal-action-container w-full fm-mb-15px" style="padding-top: 45px">
                <app-spinner-button
                    class="action cancel"
                    [actionComplete]="actionComplete"
                    [faIcon]="ismostLikelyRandomPartnerSelected ? null : faLock"
                    [label]="ctaText"
                    classes="f-btn f-btn--primary  f-btn-250"
                    (clicked)="onClickedBookSession()"></app-spinner-button>
            </div> -->

                <div class="flex flex-col items-center justify-center w-full mt-2">
                    <div class="text-muted-color text-12 leading-[normal] text-center">
                        {{ footerText }}
                    </div>

                    <p-button
                        (click)="onClickTrackLearnMoreSelected()"
                        severity="primary"
                        [link]="true">
                        <a
                            href="http://support.focusmate.com/en/articles/6385284-how-we-match-you-with-a-partner"
                            target="_blank"
                            class="font-semibold no-underline"
                            >Learn more <i class="pi pi-external-link !text-14"></i>
                        </a>
                    </p-button>
                </div>
            </div>
        </ng-template>
    </div>
</div>
